import React, { Component } from 'react'
import Img from 'react-cool-img'
import { toast } from 'react-toastify'
import { Carousel} from 'react-bootstrap'
import Modal from 'react-modal'
import { Link } from 'react-router-dom'
import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'
import 'react-sweet-progress/lib/style.css'
import ScrollToTop from 'react-scroll-to-top'
import LoadingOverlay from 'react-loading-overlay'
import Web3 from 'web3'
import ZooHarmony from '../../abis/ZooHarmony.json'
import ZooHarmonyNFT from '../../abis/ZooHarmonyNFT.json'
import ZooHarmonyNFTSale from '../../abis/ZooHarmonyNFTSale.json'
import ZooHarmonyAvatars from '../../abis/ZooHarmonyAvatars.json'
import ZooHarmonyVerified from '../../abis/ZooHarmonyVerified.json'
import ZooHarmonyNFTLikes from '../../abis/ZooHarmonyNFTLikes.json'

Modal.setAppElement('#root')

const canvasStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  width: '100%',
  height: '100%',
  zIndex: '999999',
  top: 0,
  left: 0,
}

const customStyle2 = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    backgroundColor: '#111',
    borderColor: '#004A8B',
    borderRadius: '15px',
    padding: '40px',
    color: '#151a2f',
    bottom: 'auto',
    minWidth: '350px',
    maxWidth: '650px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    
  },
}

const customStyle3 = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    backgroundColor: 'rgb(6 8 14)',
    borderColor: '#004A8B',
    borderRadius: '15px',
    padding: '40px',
    color: '#FFF',
    bottom: 'auto',
    minWidth: '350px',
    maxWidth: '650px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
}

class Landing extends Component {


  handleOpenModal() {
    this.setState({ showModal: true })
  }

  handleOpenZOOModal() {
    this.setState({ showZOOModal: true })
  }

  handleCloseModal() {
    this.setState({ showModal: false })
    localStorage.setItem('agreed', 'true')
  }

  handleCloseZOOModal() {
    this.setState({ showZOOModal: false })
  }

  render() {
    // if (document.body && document.getElementById('mainfoot')) {
      // document.body.style.backgroundImage = "url(bg.jpg)";
      // document.getElementById('mainfoot').style.display = 'none'
    // }

    return (
      <div>
        <ScrollToTop smooth/>
        <LoadingOverlay
          active={this.state.txpend}
          spinner
          transition={false}
          text={'Waiting on...' + this.state.txs + ' transaction(s)'}
          styles={{
            overlay: base => ({
              ...base,
              background: 'rgba(0, 0, 0, 0.95)',
              position: 'fixed',
            }),
            wrapper: {
              width: '100%',
              height: '100%',
              borderRadius: '25px',
            },
          }}
        >
          <Modal
            animationDuration={1000}
            isOpen={this.state.showModal}
            contentLabel="Disclaimer"
            id="modalwarn"
            align="center"
            style={customStyle3}
            overlayClassName="myoverlay"
            onRequestClose={this.handleCloseModal}
          >
            <div align="center">
              <p>
              Welcome to the <strong>ZooHarmony NFT Marketplace</strong>! This market is open and decentralized on the
              Polygon Network. Anyone can mint NFTs and list them for sale. This results in possible fakes and
                scammers. We utilize different smart contracts to "Verify" or "Blacklist" users manually. Please use due diligence when making purchases of NFTs! When you buy a NFT here you are
                directly sending that user ZOO, there is no method of refunds. If it is too good to be true, it
                probably is!
              </p>
              <button className="btn btn-primary" onClick={this.handleCloseModal} align="center">
                I Understand
              </button>
            </div>
          </Modal>
          <Modal
            animationDuration={1000}
            isOpen={this.state.showZOOModal}
            contentLabel="ZooHarmony"
            id="modalZooHarmony"
            align="center"
            style={customStyle2}
            overlayClassName="myoverlay"
            onRequestClose={this.handleCloseZOOModal}
          >
            <button
              onClick={this.handleCloseZOOModal}
              className="btn btn-primary"
              align="right"
              style={{ top: '15px', right: '15px', position: 'absolute' }}
            >
              X
            </button>
            <h2 align="center">
              <img src="/maticLogo.svg" border="0" height="66px" width="66px" /> <i className="fa fa-arrow-right"></i>{' '}
              <img src="/zooblue.svg" border="0" height="66px" width="66px" />
            </h2>
            <br />
            <div align="center">
              <p>
                <h3>
                  Swap your <strong>MATIC</strong> to <strong>ZOO</strong>
                </h3>
                <br />
                Balance{' '}
                <strong>
                  <span id="onebal">
                    {Number(this.state.onebalance)
                      .toString()
                      .slice(
                        0,
                        Number(this.state.onebalance)
                          .toString()
                          .indexOf('.') + 5,
                      )}
                  </span>
                </strong>{' '}
                MATIC
                <br />
                <br />
                <form
                  onSubmit={event => {
                    event.preventDefault()
                    this.buyZooin()
                  }}
                >
                  <input
                    type="number"
                    autoComplete="off"
                    step="any"
                    onChange={event => this.changeAmount(event.target.value)}
                    className="form-control"
                    border="0"
                    id="zooamount"
                    placeholder="Amount of MATIC"
                    style={{ padding: '20px' }}
                  />
                  <br />
                  <span>You get</span>
                  <strong>
                    ≈ <span id="amounttobuy">0</span>
                  </strong>
                  ZOO
                  <br />
                  <br />
                  <button
                    className="btn btn-primary swapbtn"
                    style={{ fontSize: '23px' }}
                    type="submit"
                    align="center"
                    disabled={window.web3 !== undefined ? false : true}
                  >
                    {window.web3 !== undefined ? 'SWAP' : 'CONNECT WALLET'}
                  </button>
                </form>
                <br />
                Balance{' '}
                <strong>
                  <span id="zoobal">{this.abbreviateNumber(Number(this.state.zoobalance))}</span>
                </strong>{' '}
                ZOO
                <br />
                <span style={{ color: '#ff5722' }}>
                  Max Balance <strong>100 Billion</strong> ZOO
                </span>
              </p>
            </div>
          </Modal>
          <div className="col-auto mx-4 align-middle" style={{ marginTop: '3vh' }}></div>
          <div className="row">
          <div className='zooTech'>
              <a href='https://docs.polygon.technology/' target='_blank' rel="noopener noreferrer">
                <div className='zooTech_image'>
                <img src="/copyright.svg"/>
                </div>
              </a>
            </div>
          <div className='col-md-12 carouselInner'>
              <Carousel fade className='carouselBanner'>
                  {/* <Carousel fade> */}
                    <Carousel.Item interval={10000} controls={false} indicators={false}>
                      <div className="col-md-2 card2 cardW100 bg-light m-3 p-2">
                          <form onSubmit={event => {}}>
                            <div className="col-auto max-550">
                              <video
                                    alt="NFT"
                                    className="token rounded"
                                    autoPlay
                                    playsInline
                                    muted
                                    loop
                                    controls
                                    src={
                                      'https://zooharmony.mypinata.cloud/ipfs/QmT1jEE2WWHtY7r8egcjsdpdL1byqorXLFmZJrTFzdJbQX '
                                    }
                                    type="video/mp4"
                                    style={{ background: '#21263e' }}
                                  >
                                    <source
                                      src={
                                        'https://zooharmony.mypinata.cloud/ipfs/QmT1jEE2WWHtY7r8egcjsdpdL1byqorXLFmZJrTFzdJbQX '
                                      }
                                      type="video/mp4"
                                    ></source>
                                  </video>
                            </div>
                          </form>
                      </div>
                    </Carousel.Item>
                    {/*  */}
                    <Carousel.Item interval={10000} controls={false} indicators={false}>
                      <div className="col-md-2 card2 cardW100 bg-light m-3 p-2 myes">
                          <form onSubmit={event => {}}>
                            <div className="col-auto max-550">
                                  <Img
                                    alt="NFT"
                                    className="token rounded"
                                    src={
                                      'https://zooharmony.mypinata.cloud/ipfs/QmRqCMTFV8A6DuNQYNqS2GLf1T5WTRQZJDGTm12kscGsrV'
                                    }
                                    cache
                                    style={{ background: '#21263e' }}
                                  />
                            </div>
                          </form>
                      </div>
                    </Carousel.Item>
                    {/*  */}
                    <Carousel.Item interval={10000} controls={false} indicators={false}>
                      <div className="col-md-2 card2 cardW100 bg-light m-3 p-2">
                          <form onSubmit={event => {}}>
                            <div className="col-auto max-550">
                              <video
                                    alt="NFT"
                                    className="token rounded"
                                    autoPlay
                                    playsInline
                                    muted
                                    loop
                                    controls
                                    src={
                                      'https://zooharmony.mypinata.cloud/ipfs/QmbduNXePR1mC8eN18QTimZDz7cGop2FRHsHPrV4RmQbvX'
                                    }
                                    type="video/mp4"
                                    style={{ background: '#21263e' }}
                                  >
                                    <source
                                      src={
                                        'https://zooharmony.mypinata.cloud/ipfs/QmbduNXePR1mC8eN18QTimZDz7cGop2FRHsHPrV4RmQbvX'
                                      }
                                      type="video/mp4"
                                    ></source>
                                  </video>
                            </div>
                          </form>
                      </div>
                    </Carousel.Item>
              </Carousel>
          </div>
            <div className="col-md-12" align="center">
              <div className="row">
                <div className="featuredContainer my-auto align-middle">
                  <div className="col-md-6 blockReact1">
                    <h1 className="g-0 g-md-1 textReact">
                    YOUR FAVORITE NFT MARKETPLACE <br/>YOU HAVE NOT SEEN YET
                    </h1>
                    <span className="subheader trsLight">ZooHarmony is all-in-one place to cut any NFT deal in a few clicks</span>
                    <div className="blockButton1">
                      <a
                        type="button"
                        href="/explore/exploreall"
                        className="btn btn-primary rounded m-3 homeButton swapbtn homeButton3 trsLight"
                      >
                        EXPLORE
                      </a>
                      <a type="button" onClick={this.handleOpenZOOModal} className="actionGroup">
                        <span className="pointer zooharmonyBuy">
                          <span className="zooharmonyBordering trsLight">BUY ZOO</span>
                        </span>
                      </a>
                    </div>
                    <div className="blockPowered" style={{display: 'block'}}>
                      <div className="poweredIconer">
                        <p className="textPowered" style={{textTransform: "uppercase"}}>
                        <span className='warningVersion'>
                        <span className='textWarning'>Polygon Mumbai Version</span>
                        {/* THIS CHANGE */}
                        </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 blockReact1">
                  <Carousel fade>
                  {/* <Carousel fade> */}
                  <Carousel.Item interval={10000}>
                  <Link
                          to={{
                            pathname: `/nft/3`,
                          }}
                        >
                      <div className="col-md-2 card cardW100 bg-light m-3 p-2">
                          <form onSubmit={event => {}}>
                            <div className="col-auto max-450">
                              <div className="text-secondary idbadge idbadgeOrange" align="center">
                              <span>Mano de Dios NFT</span>
                              </div>
                              <video
                                    alt="NFT"
                                    className="token rounded"
                                    autoPlay
                                    playsInline
                                    muted
                                    loop
                                    controls
                                    src={
                                      'https://zooharmony.mypinata.cloud/ipfs/QmT1jEE2WWHtY7r8egcjsdpdL1byqorXLFmZJrTFzdJbQX'
                                    }
                                    type="video/mp4"
                                    style={{ background: '#21263e' }}
                                  >
                                    <source
                                      src={
                                        'https://zooharmony.mypinata.cloud/ipfs/QmT1jEE2WWHtY7r8egcjsdpdL1byqorXLFmZJrTFzdJbQX'
                                      }
                                      type="video/mp4"
                                    ></source>
                                  </video>
                            </div>
                          </form>
                      </div>
                      <Carousel.Caption>
                        <h3 style={{ color: '#20ebf047' }}>PREMIUM NFT</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                      </Carousel.Caption>
                      </Link>
                    </Carousel.Item>
                    {/*  */}
                    <Carousel.Item interval={10000}>
                      <div className="col-md-2 card cardW100 bg-light m-3 p-2 myes">
                      <Link
                          to={{
                            pathname: `/nft/5`,
                          }}
                        >
                          <form onSubmit={event => {}}>
                            <div className="col-auto max-450">
                              <div className="text-secondary idbadge idbadgeYellow" align="center">
                              <span>Honorable NFT</span>
                              </div>
                                  <Img
                                    alt="NFT"
                                    className="token rounded"
                                    src={
                                      'https://zooharmony.mypinata.cloud/ipfs/QmRqCMTFV8A6DuNQYNqS2GLf1T5WTRQZJDGTm12kscGsrV'
                                    }
                                    cache
                                    style={{ background: '#21263e' }}
                                  />
                            </div>
                          </form>
                      </Link>
                      </div>
                      <Carousel.Caption>
                        <h3 style={{ color: '#20ebf047' }}>PREMIUM NFT</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                      </Carousel.Caption>
                    </Carousel.Item>
                    {/*  */}
                    <Carousel.Item interval={10000}>
                    <Link
                          to={{
                            pathname: `/nft/4`,
                          }}
                        >
                      <div className="col-md-2 card cardW100 bg-light m-3 p-2">
                          <form onSubmit={event => {}}>
                            <div className="col-auto max-450">
                              <div className="text-secondary idbadge idbadgeGreen" align="center">
                              <span>Medal of Honor NFT</span>
                              </div>
                              <video
                                    alt="NFT"
                                    className="token rounded"
                                    autoPlay
                                    playsInline
                                    muted
                                    loop
                                    controls
                                    src={
                                      'https://zooharmony.mypinata.cloud/ipfs/QmbduNXePR1mC8eN18QTimZDz7cGop2FRHsHPrV4RmQbvX'
                                    }
                                    type="video/mp4"
                                    style={{ background: '#21263e' }}
                                  >
                                    <source
                                      src={
                                        'https://zooharmony.mypinata.cloud/ipfs/QmbduNXePR1mC8eN18QTimZDz7cGop2FRHsHPrV4RmQbvX'
                                      }
                                      type="video/mp4"
                                    ></source>
                                  </video>
                            </div>
                          </form>
                      </div>
                      <Carousel.Caption>
                        <h3 style={{ color: '#20ebf047' }}>PREMIUM NFT</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                      </Carousel.Caption>
                    </Link>
                    </Carousel.Item>
                  </Carousel>
                  </div>
                </div>
              </div>
              <br />{' '}
              <div
                style={{
                  padding: '15px',
                }}
                className="intro"
              >
                <div className="row" align="center">
                  <div className="col-md-4 gryBg">
                    <strong className="trsLight">Total Value Locked</strong>
                    <br />
                    <ReactPlaceholder
                      type="rect"
                      ready={this.state.totalliquidity}
                      showLoadingAnimation={true}
                      color="#333"
                      style={{
                        width: '250px',
                        height: '50px',
                        marginBottom: '15px',
                        borderRadius: '15px',
                      }}
                    >
                      <h1 className="txtBlue" >
                        $
                        <strong>
                          {this.state.totalliquidity.toLocaleString('en', {
                            style: 'decimal',
                            maximumFractionDigits: 0,
                            minimumFractionDigits: 0,
                          })}
                        </strong>
                      </h1>
                    </ReactPlaceholder>
                  </div>
                  <div className="col-md-4 gryBg">
                    <strong className="trsLight">ZOO Market Cap</strong>
                    <br />
                    <ReactPlaceholder
                      type="rect"
                      ready={this.state.mcap}
                      showLoadingAnimation={true}
                      color="#333"
                      style={{
                        width: '250px',
                        height: '50px',
                        marginBottom: '15px',
                        borderRadius: '15px',
                      }}
                    >
                      <h1 className="txtBlue" > $
                        <strong>
                          {this.state.mcap.toLocaleString('en', {
                            style: 'decimal',
                            maximumFractionDigits: 0,
                            minimumFractionDigits: 0,
                          })}
                        </strong>{' '}
                      </h1>
                    </ReactPlaceholder>
                  </div>
                  <div className="col-md-4 gryBg">
                    <strong className="trsLight">Total NFTs</strong>
                    <br />
                    <ReactPlaceholder
                      type="rect"
                      ready={this.state.totalSupply}
                      showLoadingAnimation={true}
                      color="#333"
                      style={{
                        width: '250px',
                        height: '50px',
                        marginBottom: '15px',
                        borderRadius: '15px',
                      }}
                    >
                     <h1 className="txtBlue" >
                        <strong>{this.state.totalSupply}</strong>
                      </h1>
                    </ReactPlaceholder>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LoadingOverlay>
      </div>
    )
  }
  constructor(props) {
    super(props)
    this.state = {
      account: '',
      contract: null,
      sale_contract: null,
      totalSupply: 0,
      images: [],
      owners: [],
      percent: 0,
      oneamount: 0,
      minted: [],
      mintedcollection: '',
      onebalance: 0,
      zoobalance: 0,
      showModal: false,
      showZOOModal: false,
      totalliquidity: 0,
      totalcirc: 0,
      mcap: 0,
      txpend: false,
      txs: 0,
      imageData_name: [],
      imageData_nftData: [],
      imageData_mimeType: [],
      imageData_category: [],
      imageData_price: [],
      imageData_id: [],
      imageData_owner: [],
      imageData_icecount: [],
      imageData_likecount: [],
      mimages: [],
      mimageData_name: [],
      mimageData_nftData: [],
      mimageData_mimeType: [],
      mimageData_category: [],
      mimageData_price: [],
      mimageData_id: [],
      mimageData_owner: [],
      mimageData_icecount: [],
      mimageData_likecount: [],
      tximages: [],
      tximageData_name: [],
      tximageData_nftData: [],
      tximageData_mimeType: [],
      tximageData_category: [],
      tximageData_price: [],
      tximageData_id: [],
      tximageData_buyer: [],
      tximageData_boughtprice: [],
      tximageData_buyeripfs: [],
      tximageData_buyermim: [],
      tximageData_buyername: [],
      tximageData_verified: [],
      tximageData_usdprice: [],
      tximageData_oneprice: [],
      tximageData_icecount: [],
      tximageData_likecount: [],
      gtximages: [],
      gtximageData_name: [],
      gtximageData_nftData: [],
      gtximageData_mimeType: [],
      gtximageData_category: [],
      gtximageData_price: [],
      gtximageData_id: [],
      gtximageData_receiver: [],
      gtximageData_boughtprice: [],
      gtximageData_buyeripfs: [],
      gtximageData_buyermim: [],
      gtximageData_buyername: [],
      gtximageData_verified: [],
      feature_verified: [],
      iData_name: [],
      iData_nftData: [],
      iData_mimeType: [],
      iData_category: [],
      iData_price: [],
      iData_id: [],
      ready: false,
      ready2: false,
      ready3: false,
      readymint: false,
      selling_to: '',
      selling_price: null,
      token_sale_contract: null,
      token_price: 0,
      zooamount: 0,
      approved: [],
      blackListed: [],
      owned: '',
      ipfs: '',
      mim: '',
      name: '',
      transactions: [],
      gtransactions: [],
    }
    this.handleOpenModal = this.handleOpenModal.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleOpenZOOModal = this.handleOpenZOOModal.bind(this)
    this.handleCloseZOOModal = this.handleCloseZOOModal.bind(this)
  }

  async componentWillMount() {
    this.state.ready3 = false
    this.state.ready2 = false
    
    await this.loadBlockchainData()
  }

  makeShot = (particleRatio, opts) => {
    this.animationInstance &&
      this.animationInstance({
        ...opts,
        origin: { y: 0.7 },
        particleCount: Math.floor(200 * particleRatio),
      })
  }

  fire = () => {
    this.makeShot(0.25, {
      spread: 100,
      startVelocity: 55,
    })

    this.makeShot(0.2, {
      spread: 180,
    })

    this.makeShot(0.35, {
      spread: 150,
      decay: 0.91,
      scalar: 0.8,
    })

    this.makeShot(0.1, {
      spread: 200,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.5,
    })

    this.makeShot(0.1, {
      spread: 200,
      startVelocity: 45,
    })
  }

  handlerFire = () => {
    this.fire()
  }

  getInstance = instance => {
    this.animationInstance = instance
  }

  abbreviateNumber = number => {
    // what tier? (determines SI symbol)
    var tier = (Math.log10(Math.abs(number)) / 3) | 0

    // if zero, we don't need a suffix
    if (tier === 0) return number

    var SI_SYMBOL = ['', 'k', 'M', 'B', 'T', 'P', 'E']

    // get suffix and determine scale
    var suffix = SI_SYMBOL[tier]
    var scale = Math.pow(10, tier * 3)

    // scale the number
    var scaled = number / scale

    // format number and add suffix
    return scaled.toFixed(1) + suffix
  }

  buyZooin = () => {
    const web3 = window.web3
    this.setState({ txpend: true })
    this.setState({ txs: 2 })

    // const oneabi = [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"guy","type":"address"},{"name":"wad","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"src","type":"address"},{"name":"dst","type":"address"},{"name":"wad","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"wad","type":"uint256"}],"name":"withdraw","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"dst","type":"address"},{"name":"wad","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"deposit","outputs":[],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"src","type":"address"},{"indexed":true,"name":"guy","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"src","type":"address"},{"indexed":true,"name":"dst","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"dst","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Deposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"src","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Withdrawal","type":"event"}];

    const oneabi = [{"type":"event","inputs":[{"name":"src","type":"address","internalType":"address","indexed":true},{"type":"address","indexed":true,"name":"guy","internalType":"address"},{"internalType":"uint256","type":"uint256","indexed":false,"name":"wad"}],"anonymous":false,"name":"Approval"},{"anonymous":false,"name":"Deposit","inputs":[{"internalType":"address","name":"dst","type":"address","indexed":true},{"indexed":false,"internalType":"uint256","type":"uint256","name":"wad"}],"type":"event"},{"type":"event","anonymous":false,"inputs":[{"indexed":true,"type":"address","internalType":"address","name":"src"},{"indexed":true,"name":"dst","internalType":"address","type":"address"},{"indexed":false,"name":"wad","type":"uint256","internalType":"uint256"}],"name":"Transfer"},{"name":"Withdrawal","type":"event","inputs":[{"name":"src","indexed":true,"type":"address","internalType":"address"},{"type":"uint256","indexed":false,"name":"wad","internalType":"uint256"}],"anonymous":false},{"name":"allowance","type":"function","stateMutability":"view","outputs":[{"internalType":"uint256","type":"uint256","name":""}],"inputs":[{"name":"","type":"address","internalType":"address"},{"type":"address","internalType":"address","name":""}]},{"type":"function","inputs":[{"name":"","type":"address","internalType":"address"}],"name":"balanceOf","stateMutability":"view","outputs":[{"name":"","type":"uint256","internalType":"uint256"}]},{"inputs":[],"stateMutability":"view","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"name":"decimals","type":"function"},{"outputs":[{"internalType":"string","name":"","type":"string"}],"name":"name","type":"function","stateMutability":"view","inputs":[]},{"name":"symbol","type":"function","inputs":[],"stateMutability":"view","outputs":[{"type":"string","internalType":"string","name":""}]},{"type":"receive","stateMutability":"payable"},{"stateMutability":"payable","name":"deposit","type":"function","inputs":[],"outputs":[]},{"name":"withdraw","type":"function","outputs":[],"inputs":[{"type":"uint256","name":"wad","internalType":"uint256"}],"stateMutability":"nonpayable"},{"name":"totalSupply","inputs":[],"stateMutability":"view","outputs":[{"name":"","internalType":"uint256","type":"uint256"}],"type":"function"},{"inputs":[{"type":"address","internalType":"address","name":"guy"},{"type":"uint256","internalType":"uint256","name":"wad"}],"type":"function","stateMutability":"nonpayable","name":"approve","outputs":[{"type":"bool","internalType":"bool","name":""}]},{"name":"transfer","stateMutability":"nonpayable","type":"function","inputs":[{"name":"dst","internalType":"address","type":"address"},{"internalType":"uint256","type":"uint256","name":"wad"}],"outputs":[{"name":"","internalType":"bool","type":"bool"}]},{"name":"transferFrom","type":"function","inputs":[{"internalType":"address","name":"src","type":"address"},{"name":"dst","internalType":"address","type":"address"},{"name":"wad","type":"uint256","internalType":"uint256"}],"outputs":[{"name":"","type":"bool","internalType":"bool"}],"stateMutability":"nonpayable"}]


    const zooharmonyabi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[{"internalType":"uint256","name":"zooAmount","type":"uint256"}],"name":"getEstimatedONEforZOO","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"oneAmount","type":"uint256"}],"name":"getEstimatedZOOforONE","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"uniswapRouter","outputs":[{"internalType":"contract IUniswapV2Router02","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"zooAmount","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"zooharmony","outputs":[],"stateMutability":"payable","type":"function"},{"stateMutability":"payable","type":"receive"}]


    const contractzooharmony = new web3.eth.Contract(zooharmonyabi, '0x45658fAA8e4BD7598aC435786B011E926bbEAF81') // ZooHarmonyViper

    const contractone = new web3.eth.Contract(oneabi, '0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889') // WONE

    const slippage = this.state.zooamount

    // console.log(slippage)

    contractzooharmony.methods
      .getEstimatedONEforZOO(slippage.toString())
      .call()
      .then(receipt => {
        const estone = receipt[0]
        // console.log(estone)

        contractone.methods
          .approve('0x45658fAA8e4BD7598aC435786B011E926bbEAF81', estone)
          .send({ from: this.state.account })
          .once('receipt', receipt => {
            this.setState({ txpend: true })
            this.setState({ txs: 1 })

            // make new deadline one hour from now in epoch unix time
            const deadline = Math.floor(Date.now() / 1000) + 6000
            // console.log(deadline)

            contractzooharmony.methods
              .zooharmony(slippage.toString(), deadline)
              .send({ from: this.state.account, value: estone })
              .once('receipt', async receipt => {
                this.setState({ txpend: false })
                this.setState({ txs: 0 })

                this.handlerFire()

                //console.log(receipt);

                console.log('Finishing MATIC to ZOO successfully!')
              })
              .catch(error => {

                toast.error("Transaction failed on the second step from MATIC!")
                this.setState({ txpend: false })
              })
          })
          .catch(error => {
            // Transaction rejected or failed
            console.log(error)
            toast.error("Transaction failed on MATIC approval!")
            this.setState({ txpend: false })
          })
      })
      .catch(error => {
        console.log(error)
        toast.error("Failed to get ZooHarmony estimate!")
        this.setState({ txpend: false })
      })
  }

  changeAmount = amount => {
    if (amount > 0) {

      const web3 = new Web3('https://matic-mumbai.chainstacklabs.com')

      const zooharmonyabi2 = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[{"internalType":"uint256","name":"zooAmount","type":"uint256"}],"name":"getEstimatedONEforZOO","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"oneAmount","type":"uint256"}],"name":"getEstimatedZOOforONE","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"uniswapRouter","outputs":[{"internalType":"contract IUniswapV2Router02","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"zooAmount","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"zooharmony","outputs":[],"stateMutability":"payable","type":"function"},{"stateMutability":"payable","type":"receive"}]


      const contractzooharmony2 = new web3.eth.Contract(zooharmonyabi2, '0x45658fAA8e4BD7598aC435786B011E926bbEAF81')

      // console.log(slippage);

      this.setState({ oneamount: amount })

      var SI_SYMBOL = ['', 'k', 'M', 'B', 'T', 'P', 'E']

      function abbreviateNumber(number) {
        // what tier? (determines SI symbol)
        var tier = (Math.log10(Math.abs(number)) / 3) | 0

        // if zero, we don't need a suffix
        if (tier == 0) return number

        // get suffix and determine scale
        var suffix = SI_SYMBOL[tier]
        var scale = Math.pow(10, tier * 3)

        // scale the number
        var scaled = number / scale

        // format number and add suffix
        return scaled.toFixed(1) + suffix
      }

      contractzooharmony2.methods
        .getEstimatedZOOforONE(web3.utils.toWei(amount.toString(), 'ether'))
        .call()
        .then(receipt => {
          const estzoo = receipt[1]
          // console.log(estzoo)

          this.setState({ zooamount: estzoo })

          document.getElementById('amounttobuy').innerHTML = abbreviateNumber(estzoo / 1e18)
        })
        .catch(error => {
          // console.log(error)
          toast.error('Failed to get ZooHarmony estimate!')
        })
    } else {
      document.getElementById('amounttobuy').innerHTML = 0
    }
  }

  async like(e, owner, key) {
    e.preventDefault()
    e.stopPropagation()

    document.getElementById('like' + key).classList.add('fa-pulse')

    const web3t = window.web3

    const accounts = await window.web3.eth.getAccounts()
    const acct = accounts[0]
    // console.log('set account')

    const abilike = ZooHarmonyNFTLikes.abi
    const contractlike = new web3t.eth.Contract(abilike, '0x0577e2163cccE36a83b658e682Abd7643b16EfE0')

    contractlike.methods
      .LikeNFT(owner, key)
      .send({ from: acct })
      .once('receipt', receipt => {
        toast.success("Liked Succeed, Sweet!")
        document.getElementById('like' + key).classList.remove('fa-pulse')
        document.getElementById('like' + key).classList.add('liked')
        document.getElementById('count' + key).innerHTML = Number(document.getElementById('count' + key).innerHTML) + 1

        // this.setState({ txpend: false })
        // this.setState({ txs: 0 })
      })
      .catch(error => {
        // Transaction rejected or failed
        document.getElementById('like' + key).classList.remove('fa-pulse')
        toast.error("Like failed!")
        // console.log(error)
        // this.setState({ txpend: false });
      })
  }

  async ice(e, owner, key) {
    e.preventDefault()
    e.stopPropagation()

    document.getElementById('ice' + key).classList.add('fa-pulse')

    const web3t = window.web3

    const web3one = new Web3('https://matic-mumbai.chainstacklabs.com')

    const accounts = await window.web3.eth.getAccounts()
    const acct = accounts[0]
    // console.log('set account')

    const networkId = 80001
    const networkData = ZooHarmonyNFT.networks[networkId]
    const abi = ZooHarmonyNFT.abi
    const address = networkData.address
    const contract = new web3one.eth.Contract(abi, address)

    // Get minter of NFT
    const minted = await contract.getPastEvents('Transfer', {
      fromBlock: 25597058,
      toBlock: 'latest',
    })

    for (var i = 0; i < minted.length; i++) {
      this.setState({ minted: [...this.state.minted, minted[i].returnValues] })
    }

    // console.log(this.state.minted)

    for (i = 0; i < this.state.minted.length; i++) {
      // console.log(this.state.transactions[i]._buyer)
      // console.log(this.state.minted[i].tokenId)
      if (this.state.minted[i].tokenId == key) {
        // console.log('hoorah!');
        if (this.state.minted[i].from == '0x0000000000000000000000000000000000000000') {
          // console.log('hoorah TWICE!')
          // console.log(this.state.minted[i].to);
          this.setState({ mintedcollection: this.state.minted[i].to })
        }
      }
    }

    // console.log(this.state.mintedcollection)

    const abilike = ZooHarmonyNFTLikes.abi
    const contractlike = new web3t.eth.Contract(abilike, '0x0577e2163cccE36a83b658e682Abd7643b16EfE0')

    const abib = ZooHarmony.abi
    const addressb = '0x9Da20fB6362538caa35cB0414C48D853a61d99EA'
    const token_contract = new web3t.eth.Contract(abib, addressb)

    const iceprice = '10'

    token_contract.methods
      .approve('0x0577e2163cccE36a83b658e682Abd7643b16EfE0', web3one.utils.toWei(iceprice, 'ether'))
      .send({ from: acct })
      .once('receipt', receipt => {
        contractlike.methods
          .IceNFT(this.state.mintedcollection, key)
          .send({ from: acct })
          .once('receipt', receipt => {
            toast.success("Pacmanised Succeed, Sweet!")
            document.getElementById('ice' + key).classList.remove('fa-pulse')
            document.getElementById('ice' + key).classList.add('iced')
            document.getElementById('counti' + key).innerHTML =
              Number(document.getElementById('counti' + key).innerHTML) + 10

            // this.setState({ txpend: false })
            // this.setState({ txs: 0 })
          })
          .catch(error => {
            // Transaction rejected or failed
            document.getElementById('ice' + key).classList.remove('fa-pulse')
            toast.error("Pacmaned Failed, need 10 zoo!")
            // console.log(error)
            // this.setState({ txpend: false });
          })
      })
      .catch(error => {
        // Transaction rejected or failed
        document.getElementById('ice' + key).classList.remove('fa-pulse')
        toast.error("Pacmaned Failed, need 100 zoo!")
        // console.log(error)
        // this.setState({ txpend: false });
      })
  }

  async loadBlockchainData() {
    // window.loaded_web3 = false;

    function randomNumber(min, max) {
      return Math.random() * (max - min) + min
    }

    if (localStorage.getItem('agreed') === 'true') {
      this.setState({ showModal: false })
    } else {
      this.setState({ showModal: true })
    }

    const web3 = window.web3

    const web3t = new Web3('https://matic-mumbai.chainstacklabs.com')

    // Load account

    if (typeof web3 !== 'undefined') {
      const accounts = await web3.eth.getAccounts()
      this.setState({ account: accounts[0] })
      this.setState({ connected: true })
      const chainId = await web3.eth.getChainId()
      if (chainId === 80001) {
        this.setState({ connected: true })
        // console.log(this.state.connected)
        // console.log(this.state.account)
      } else {
        this.setState({ connected: false })
      }
    }

    setInterval(async () => {
      if (typeof web3 !== 'undefined' && this.state.showZOOModal === true) {
        const onebalance = web3.utils.fromWei(await web3.eth.getBalance(this.state.account), 'ether')
        if (onebalance > 0 && typeof onebalance !== 'undefined') {
          this.setState({ onebalance })

          document.getElementById('onebal').innerHTML = Number(onebalance).toFixed(4)

          const abia = ZooHarmony.abi
          const addr = '0x9Da20fB6362538caa35cB0414C48D853a61d99EA'
          const contract = new web3.eth.Contract(abia, addr)
          const zoobal = await contract.methods.balanceOf(this.state.account).call()
          if (zoobal > 0 && zoobal !== null) {
            const zoobalance2 = web3.utils.fromWei(zoobal, 'ether')
            const zoobalance = zoobalance2

            this.setState({ zoobalance })

            document.getElementById('zoobal').innerHTML = this.abbreviateNumber(Number(zoobalance))
          }
        }
      }
      const abip = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"getLatestONEPrice","outputs":[{"internalType":"int256","name":"","type":"int256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"pairAddress","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getLatestTokenPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"}]

      const addp = '0xdC49E176c43ff92816F174Dc7fBd1Ff2923B2528' // ZooHarmonyPriceOracle
      const contractp = new web3t.eth.Contract(abip, addp)
      this.setState({ contractp })

      const oneabi = [{"type":"event","inputs":[{"name":"src","type":"address","internalType":"address","indexed":true},{"type":"address","indexed":true,"name":"guy","internalType":"address"},{"internalType":"uint256","type":"uint256","indexed":false,"name":"wad"}],"anonymous":false,"name":"Approval"},{"anonymous":false,"name":"Deposit","inputs":[{"internalType":"address","name":"dst","type":"address","indexed":true},{"indexed":false,"internalType":"uint256","type":"uint256","name":"wad"}],"type":"event"},{"type":"event","anonymous":false,"inputs":[{"indexed":true,"type":"address","internalType":"address","name":"src"},{"indexed":true,"name":"dst","internalType":"address","type":"address"},{"indexed":false,"name":"wad","type":"uint256","internalType":"uint256"}],"name":"Transfer"},{"name":"Withdrawal","type":"event","inputs":[{"name":"src","indexed":true,"type":"address","internalType":"address"},{"type":"uint256","indexed":false,"name":"wad","internalType":"uint256"}],"anonymous":false},{"name":"allowance","type":"function","stateMutability":"view","outputs":[{"internalType":"uint256","type":"uint256","name":""}],"inputs":[{"name":"","type":"address","internalType":"address"},{"type":"address","internalType":"address","name":""}]},{"type":"function","inputs":[{"name":"","type":"address","internalType":"address"}],"name":"balanceOf","stateMutability":"view","outputs":[{"name":"","type":"uint256","internalType":"uint256"}]},{"inputs":[],"stateMutability":"view","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"name":"decimals","type":"function"},{"outputs":[{"internalType":"string","name":"","type":"string"}],"name":"name","type":"function","stateMutability":"view","inputs":[]},{"name":"symbol","type":"function","inputs":[],"stateMutability":"view","outputs":[{"type":"string","internalType":"string","name":""}]},{"type":"receive","stateMutability":"payable"},{"stateMutability":"payable","name":"deposit","type":"function","inputs":[],"outputs":[]},{"name":"withdraw","type":"function","outputs":[],"inputs":[{"type":"uint256","name":"wad","internalType":"uint256"}],"stateMutability":"nonpayable"},{"name":"totalSupply","inputs":[],"stateMutability":"view","outputs":[{"name":"","internalType":"uint256","type":"uint256"}],"type":"function"},{"inputs":[{"type":"address","internalType":"address","name":"guy"},{"type":"uint256","internalType":"uint256","name":"wad"}],"type":"function","stateMutability":"nonpayable","name":"approve","outputs":[{"type":"bool","internalType":"bool","name":""}]},{"name":"transfer","stateMutability":"nonpayable","type":"function","inputs":[{"name":"dst","internalType":"address","type":"address"},{"internalType":"uint256","type":"uint256","name":"wad"}],"outputs":[{"name":"","internalType":"bool","type":"bool"}]},{"name":"transferFrom","type":"function","inputs":[{"internalType":"address","name":"src","type":"address"},{"name":"dst","internalType":"address","type":"address"},{"name":"wad","type":"uint256","internalType":"uint256"}],"outputs":[{"name":"","type":"bool","internalType":"bool"}],"stateMutability":"nonpayable"}]


      const contractone = new web3t.eth.Contract(oneabi, '0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889')

      const oneprice = (await contractp.methods.getLatestONEPrice().call()) / 1e8
      const zooperone = await contractp.methods.getLatestTokenPrice('0x15215d5850279f20e27ec36c9fe57479472297c4', 1).call() 
      const zoousd = oneprice / (zooperone / 1e18)
      // console.log('ZOO-MATIC', zooperone)
      // console.log('ZOO-USD', zoousd)
      // console.log('MATIC PRICE', oneprice)

      const mcap = Number(10 * zoousd)  // total supply / circ supply


      const balONElp = await contractone.methods.balanceOf('0x15215d5850279F20e27ec36c9fE57479472297c4').call() 
      {/* THIS CHANGE */}
      const balZDEXONElp = await contractone.methods.balanceOf('0x168Ee3D55Afb4B4e192F0E8A6c2B7bB1D0847952').call() 
      const balUSDC = await contractone.methods.balanceOf('0x31345AD748caC252F7aC0fAbcb019Bb4E480AE44').call() 
      const balZOO = await contractone.methods.balanceOf('0x3Af915eDD61e4E5Ec7f339a25d99162567C61058').call() 
      const balDEZU = await contractone.methods.balanceOf('0xA66f4Bc87DD3575b563aa95130440F19bb0D21e2').call() 
      const balUSDCZDEX = await contractone.methods.balanceOf('0xb0849134Ddc5F5A42B7F2df74817eBbc098ECd8E').call() 
      const balZOOUSDC = await contractone.methods.balanceOf('0xceD7569fE6aC335913FD92F1761D09Fd33c96a37').call()  

      // console.log('ZOO - MATIC BALANCE', balONElp)
      // console.log('ZOO - USDC BALANCE', balZOOUSDC)

      var combine = 0
      combine = balONElp / 1e18
      combine += balZDEXONElp / 1e18
      combine += balUSDC / 1e18
      combine += balZOO / 1e18
      combine += balDEZU / 1e18
      combine += balUSDCZDEX / 1e18
      combine += balZOOUSDC / 1e18

      // console.log(combine)
      const totalliquidity = combine * oneprice * 2

      // const totalliquidity = (balONElp / 1e18) * oneprice * 2;


      const abia = ZooHarmony.abi
      const addr = '0x9Da20fB6362538caa35cB0414C48D853a61d99EA'
      const contract = new web3t.eth.Contract(abia, addr)
      const zoobal = await contract.methods.balanceOf('0x000000000000000000000000000000000000dead').call()
      const dead = web3t.utils.fromWei(zoobal, 'ether')

      const totalcirc = 1000 - dead

      this.setState({ mcap })
      this.setState({ totalliquidity })
      this.setState({ totalcirc })
      console.log("Total Circulasi:", totalcirc)

      const networkData = ZooHarmonyNFT.networks[networkId]
      const abi = ZooHarmonyNFT.abi
      const address = networkData.address
      const contractnft = new web3t.eth.Contract(abi, address)

      const totalSupply = await contractnft.methods.totalSupply().call()
      // console.log(totalSupply)
      this.setState({ totalSupply })
    }, 100)

    const networkId = 80001

    const blackListed = []
    this.setState({ blackListed })

    const sale_networkData = ZooHarmonyNFTSale.networks[networkId]
    const sale_abi = ZooHarmonyNFTSale.abi
    const sale_address = sale_networkData.address
    const sale_contract = new web3t.eth.Contract(sale_abi, sale_address)
    this.setState({ sale_contract })

    const networkData = ZooHarmonyNFT.networks[networkId]
    const abi = ZooHarmonyNFT.abi
    const address = networkData.address
    const contract = new web3t.eth.Contract(abi, address)

    const abiv = ZooHarmonyVerified.abi
    const addv = '0x9f37652aA27668F7e98D8bDe8B3057048cB94622' // ZooHarmony Verified
    const contractv = new web3t.eth.Contract(abiv, addv)

    const abia = ZooHarmonyAvatars.abi
    const addr = '0x3793fE28b3EbddEAf38437710cC6f843c70154E5'
    const contractav = new web3t.eth.Contract(abia, addr)

    const abip = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"getLatestONEPrice","outputs":[{"internalType":"int256","name":"","type":"int256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"pairAddress","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getLatestTokenPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"}]

    const addp = '0xdC49E176c43ff92816F174Dc7fBd1Ff2923B2528' //priceoracle
    const contractp = new web3t.eth.Contract(abip, addp)
    this.setState({ contractp })

    const oneprice = (await contractp.methods.getLatestONEPrice().call()) / 1e8
    const zooperone = await contractp.methods
      .getLatestTokenPrice('0x15215d5850279f20e27ec36c9fe57479472297c4', 1)
      .call() //PAIRS
    const zoousd = oneprice / (zooperone / 1e18)

    const abilike = ZooHarmonyNFTLikes.abi
    const contractlike = new web3t.eth.Contract(abilike, '0x0577e2163cccE36a83b658e682Abd7643b16EfE0')


    const abiblack = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"hashAddress","type":"address"},{"indexed":false,"internalType":"bool","name":"blacklisted","type":"bool"}],"name":"SetBlackListedAddress","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"nftID","type":"uint256"},{"indexed":false,"internalType":"bool","name":"blacklisted","type":"bool"}],"name":"SetBlackListedNFT","type":"event"},{"inputs":[],"name":"AddyCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"IDCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"blAddress","type":"address"}],"name":"getBlackListedAddress","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"nftID","type":"uint256"}],"name":"getBlackListedNFT","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"idupdates","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"addy","type":"address"},{"internalType":"bool","name":"blacklisted","type":"bool"}],"name":"setBlackListedAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"nftID","type":"uint256"},{"internalType":"bool","name":"blacklisted","type":"bool"}],"name":"setBlackListedNFT","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"updates","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}];

    const contractblack = new web3t.eth.Contract(abiblack, '0x52533B602Fa9ffed7BaA276154d5295F4B1B633B')


    var SI_SYMBOL = ['', 'k', 'M', 'B', 'T', 'P', 'E']

    function abbreviateNumber(number) {
      // what tier? (determines SI symbol)
      var tier = (Math.log10(Math.abs(number)) / 3) | 0

      // if zero, we don't need a suffix
      if (tier == 0) return number

      // get suffix and determine scale
      var suffix = SI_SYMBOL[tier]
      var scale = Math.pow(10, tier * 3)

      // scale the number
      var scaled = number / scale

      // format number and add suffix
      return scaled.toFixed(1) + suffix
    }

    if (typeof web3 !== 'undefined') {
      const onebalance = web3.utils.fromWei(await web3.eth.getBalance(this.state.account), 'ether')
      this.setState({ onebalance })
      // console.log(onebalance)
    }
    if (typeof web3 !== 'undefined') {
      const abia = ZooHarmony.abi
      const addr = '0x9Da20fB6362538caa35cB0414C48D853a61d99EA'
      const contract = new web3.eth.Contract(abia, addr)
      const zoobal = await contract.methods.balanceOf(this.state.account).call()
      const zoobalance2 = web3.utils.fromWei(zoobal, 'ether')
      const zoobalance = zoobalance2

      this.setState({ zoobalance })
    }

    this.setState({ contractblack })

    this.setState({ contractlike })

    // console.log(contract)
    this.setState({ contractav })
    // console.log(contract)
    this.setState({ contractv })

    this.setState({ contract })

    const totalSupply = await contract.methods.totalSupply().call()
    // console.log(totalSupply)
    this.setState({ totalSupply })

    // console.log(sale_contract)
    const transactions = await sale_contract.getPastEvents('BoughtNFT', {
      fromBlock: 25597058,
      toBlock: 'latest',
    })

    const gtransactions = await sale_contract.getPastEvents('GiftedNFT', {
      fromBlock: 25597058,
      toBlock: 'latest',
    })
    // console.log(transactions)

    // if (this.state.transactions !== transactions) {
    this.setState({ transactions: transactions })

    this.setState({ gtransactions: gtransactions })
    // }
  }
}

export default Landing
